<template>
  <section class="header-lang">
    <div class="header-lang__flag header-lang__flag--current" @click="openLanguageSelector">
      <img v-if="currentFlagImageUrl" :src="currentFlagImageUrl" :alt="currentFlagImageAlt" />
      <i class="uil uil-angle-down"></i>
    </div>
    <transition name="bbUpMin">
      <aside
        class="header-lang__dropdown-languages"
        v-if="showLanguageSelector"
        v-click-outside="config"
      >
        <div class="header-lang__flags">
          <div class="header-lang__flag" @click="selectLanguage('es-ES')" v-show="currentFlag !== 'es'">
            <img :src="flags.es" :alt="$t('languageSelector.alternativeText.es')" />
            <span class="header-lang__language">Español</span>
          </div>
          <div class="header-lang__flag" @click="selectLanguage('fr-FR')" v-show="currentFlag !== 'fr'">
            <img :src="flags.fr" :alt="$t('languageSelector.alternativeText.fr')" />
            <span class="header-lang__language">Français</span>
          </div>
          <div class="header-lang__flag" @click="selectLanguage('it-IT')" v-show="currentFlag !== 'it'">
            <img :src="flags.it" :alt="$t('languageSelector.alternativeText.it')" />
            <span class="header-lang__language">Italiano</span>
          </div>
          <div class="header-lang__flag" @click="selectLanguage('en-GB')" v-show="currentFlag !== 'en'">
            <img :src="flags.en" :alt="$t('languageSelector.alternativeText.en')" />
            <span class="header-lang__language">English</span>
          </div>
          <div class="header-lang__flag" @click="selectLanguage('de-DE')" v-show="currentFlag !== 'de'">
            <img :src="flags.de" :alt="$t('languageSelector.alternativeText.de')" />
            <span class="header-lang__language">Deutsch</span>
          </div>
          <div class="header-lang__flag" @click="selectLanguage('nl-NL')" v-show="currentFlag !== 'nl'">
            <img :src="flags.nl" :alt="$t('languageSelector.alternativeText.nl')" />
            <span class="header-lang__language">Nederlands</span>
          </div>
          <div class="header-lang__flag" @click="selectLanguage('pt-BR')" v-show="currentFlag !== 'pt'">
            <img :src="flags.pt" :alt="$t('languageSelector.alternativeText.br')" />
            <span class="header-lang__language">Português</span>
          </div>
        </div>
      </aside>
    </transition>
  </section>
</template>

<script>
import vClickOutside from "v-click-outside";

import flagEs from "../../assets/img/ico/ico-bandera-es.svg";
import flagFr from "../../assets/img/ico/ico-bandera-fr.svg";
import flagIt from "../../assets/img/ico/ico-bandera-it.svg";
import flagEn from "../../assets/img/ico/ico-bandera-gb.svg";
import flagDe from "../../assets/img/ico/ico-bandera-de.svg";
import flagNl from "../../assets/img/ico/ico-bandera-nl.svg";
import flagBr from "../../assets/img/ico/ico-bandera-br.svg";
const FLAGS = {
  es: flagEs,
  fr: flagFr,
  it: flagIt,
  en: flagEn,
  de: flagDe,
  nl: flagNl,
  pt: flagBr,
};

function is_server() {
  return !(typeof window !== "undefined" && window.document);
}

export default {
  name: "SelectorIdioma",
  props: {
    guestLanguage: {
      type: String,
      default: "es-ES",
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      config: {
        handler: this.closeLanguageSelector,
      },
      showLanguageSelector: false,
      flags: FLAGS,
    };
  },
  computed: {
    currentFlag() {
      const lang = this.getLanguageWithoutCountry(this.guestLanguage);
      return ["es", "fr", "it", "en", "de", "nl", "pt"].includes(lang) ? lang : "es";
    },
    currentFlagImageUrl() {
      return this.flags[this.currentFlag];
    },
    currentFlagImageAlt() {
      return this.$t(`languageSelector.alternativeText.${this.currentFlag}`);
    },
  },
  methods: {
    openLanguageSelector() {
      this.showLanguageSelector = true;
    },
    closeLanguageSelector() {
      this.showLanguageSelector = false;
    },
    disableBodyScroll() {
      if (!is_server()) {
        document.body.classList.add("language-selector-open");
      }
    },
    enableBodyScroll() {
      if (!is_server()) {
        document.body.classList.remove("language-selector-open");
      }
    },
    selectLanguage(languageCode) {
      const shortLang = this.getLanguageWithoutCountry(languageCode);
      const supported = ['fr', 'en', 'it', 'de', 'nl', 'pt'];
      
      // Redirigir según el idioma seleccionado
      if (supported.includes(shortLang)) {
        this.$router.push(`/${shortLang}`);
      } else {
        // Español o no soportado = raíz sin prefijo
        this.$router.push('/');
      }

      this.closeLanguageSelector();
    },
    getLanguageWithoutCountry(languageCode) {
      return (languageCode || "").split("-")[0];
    },
  },
};
</script>

<style scoped>
/* Aquí mantienes tu estilo original */
</style>
